/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

export default class WorkerBuilder extends Worker {
  constructor(worker) {
    const code = worker.toString()
    const blob = new Blob([`(${code})()`])

    return new Worker(URL.createObjectURL(blob))
  }
}
